'use strict';

import { openDB } from 'idb'

class CvCache {
    static IDB_STORAGE_NAME = 'corvitals'
    static IDB_STORAGE_VERSION = 1
    static IDB_STORE_VALUES = 'cache'

    constructor() {
        this.cvCache = openDB(CvCache.IDB_STORAGE_NAME, CvCache.IDB_STORAGE_VERSION, {
            upgrade(db, oldVersion, newVersion, tx) {
                const version = oldVersion || 0;
                console.debug(`CvCache.upgrade(oldVersion: ${version})`);
                if (version < 1) {
                    db.createObjectStore(CvCache.IDB_STORE_VALUES);
                }
            }
        });
    }

    async get(key) {
        return new Promise((resolve, reject) => {
            this.cvCache.then(db => {
                return db.get(CvCache.IDB_STORE_VALUES, key)
                    .then(function (value) {
                        if (value && value.expiration && value.expiration < Date.now()) {
                            console.debug(`Value ${key} expired and will be removed.`);
                            db.delete(CvCache.IDB_STORE_VALUES, key);
                            value = null;
                        }
                        return resolve(typeof value === 'undefined' || !value ? null : value.value);
                    })
                    .catch(reject);
            });
        });
    }

    async put(key, value, expiration) {
        const end = typeof expiration !== 'undefined' ? Date.now() + expiration : null;
        console.debug(`CvCache.put(${key}, ${value}, ${expiration} => ${end})`);
        return this.cvCache.then(db => {
            db.put(CvCache.IDB_STORE_VALUES, {
                'expiration': end,
                value
            }, key);
        });
    }
    async del(key) { return (await this.cvCache).delete(CvCache.IDB_STORE_VALUES, key); }
}

window.cvCache = new CvCache();
